import React from 'react';
import { observer } from 'mobx-react';
import List from './List'
import { Tabs, Tab } from '../../components/route-tabs';

@observer
export default class MainMenu extends React.Component {
	render() {
		return <>
			<Tabs>
				<Tab path="/admin/mainmenu/info" exact title="Информация"><List column={1} /></Tab>
				<Tab path="/admin/mainmenu/structure" exact title="Структура"><List column={2} /></Tab>
				<Tab path="/admin/mainmenu/activity" exact title="Деятельность"><List column={3} /></Tab>
				<Tab path="/admin/mainmenu/events" exact title="События"><List column={4} /></Tab>
			</Tabs>
		</>
	}
}
